import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render Annual Report section for selections tab
 */
const AnnualReportSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="annual-report-section-component">
      <AccordionV2
        testId="annual-report"
        className="border-x py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Best Annual Report" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 pt-4">
          <p>
            Annual reports of all SGX-listed companies will go through a
            two-stage screening process. All annual reports are screened
            preliminarily by reference to the presence of key information
            stipulated in the Best Annual Report Award preliminary screening
            criteria.
          </p>

          <p>
            The Best Annual Report Award Judging Panel subsequently assesses
            each shortlisted annual report against the detailed marking
            criteria, taking into account the quality and presentation of
            information.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default AnnualReportSection;
